'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _indexWeex = require('weex-bindingx/lib/index.weex.js');

var _indexWeex2 = _interopRequireDefault(_indexWeex);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _index = require('../../index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animation = weex.requireModule('animation'); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var dom = weex.requireModule('dom');
exports.default = {
  props: {
    containerStyle: {
      type: Object,
      default: function _default() {
        return {
          backgroundColor: '#dddddd',
          borderTopColor: '#dddddd',
          borderTopWidth: 1
        };
      }
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    height: {
      type: Number,
      default: 90
    },
    styles: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      mobileX: 0,
      webStarX: 0,
      saveIdx: null,
      isAndroid: _utils2.default.env.isAndroid(),
      isIOS: _utils2.default.env.isIOS()
      /* heightChoice: 0 */
    };
  },

  methods: {
    special: function special(dom, styles) {
      animation.transition(dom, {
        styles: styles,
        duration: 200, //ms
        timingFunction: 'ease',
        delay: 10 //ms
      });
    },
    onRightNode: function onRightNode(pNode, node, i) {
      node.onPress();
      if (pNode.autoClose) this.special(this.$refs.skid[i], {
        transform: 'translate(0, 0)'
      });
    },
    onNodeClick: function onNodeClick(node, i) {
      if (this.mobileX < 0) {
        this.mobileX = 0;
        this.special(this.$refs.skid[this.saveIdx], {
          transform: 'translate(0, 0)'
        });
        this.isAndroid && this.special(this.$refs.skid[i], {
          transform: 'translate(0, 0)'
        });
      } else {
        this.$emit('onNodeClick', node, i);
      }
    },
    onPanEnd: function onPanEnd(e, node, i) {
      if (_utils2.default.env.isWeb()) {
        var webEndX = e.changedTouches[0].pageX;
        this.movingDistance(webEndX - this.webStarX, node, this.$refs.skid[i]);
      }
    },

    onPanStart: function onPanStart(e, node, i) {
      var saveIdx = this.saveIdx;

      if (saveIdx !== i && saveIdx !== null && this.$refs.skid[saveIdx]) {
        this.special(this.$refs.skid[saveIdx], {
          transform: 'translate(0, 0)'
        });
        this.mobileX = 0;
      }
      this.saveIdx = i;
      !_utils2.default.env.isWeb() ? this.mobile(e, node, i) : this.web(e, node, i);
      e.stopPropagation();
    },
    web: function web(e, node, i) {
      this.webStarX = e.changedTouches[0].pageX;
    },
    mobile: function mobile(e, node, i) {
      var _this = this;

      var el = this.$refs['skid'][i];
      _indexWeex2.default.bind({
        anchor: el.ref,
        eventType: 'pan',
        props: [{
          element: el.ref,
          property: 'transform.translateX',
          expression: 'x+' + (this.isAndroid ? 0 : this.mobileX)
        }]
      }, function (e) {
        var state = e.state,
            deltaX = e.deltaX;

        if (state === 'end') {
          _this.mobileX += deltaX;
          _this.movingDistance(_this.mobileX, node, el);
        }
      });
    },
    movingDistance: function movingDistance(scope, node, el) {
      var len = node.right ? node.right.length : 0;
      var distance = len * -160;
      if (scope < -20) {
        this.special(el, {
          transform: 'translate(' + distance + 'px, 0)'
        });
        this.mobileX = distance;
      } else {
        this.special(el, {
          transform: 'translate(0, 0)'
        });
        this.mobileX = 0;
      }
    }
  },
  computed: {
    heightChoice: function heightChoice() {
      var h = 0;
      if (this.isAndroid) {
        h = this.height / 2 - 39;
      } else if (this.isIOS) {
        h = this.height / 2 - 42;
      }
      return h;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-swipe-list/index.vue
// module id = 405
// module chunks = 0 1